'use client'

import {FC} from 'react'

import {BreadcrumbStep} from '@/app/lib/structuredData'
import {QuestionsAndAnswersQuestionPage} from '@/components/questions-and-answers/page/QuestionsAndAnswersQuestionPage'
import {RecentArticleCard} from '@/utils/contentful'
import {DynamicPriceSheets} from '@/utils/pricing'
import {QuestionsAndAnswersContentType} from '@/utils/questions-and-answers/constants'
import {
  QuestionsAndAnswersAuthor,
  QuestionsAndAnswersCategory,
  QuestionsAndAnswersItem,
  QuestionsAndAnswersRelatedQuestion,
} from '@/utils/questions-and-answers/types'
import {getRelatedServiceContent} from '@/utils/related-services/helpers'
import {analytics} from '@/utils/tracking/analytics'

const QA_TYPE = QuestionsAndAnswersContentType.trademark

type TrademarkQAQuestionProps = {
  breadcrumbTrail: BreadcrumbStep[]
  category: QuestionsAndAnswersCategory
  question: QuestionsAndAnswersItem
  relatedQuestions: QuestionsAndAnswersRelatedQuestion[]
  relatedArticles: RecentArticleCard[]
  author: QuestionsAndAnswersAuthor
  prices: DynamicPriceSheets
}

const TrademarkQAQuestion: FC<TrademarkQAQuestionProps> = ({
  breadcrumbTrail,
  category,
  question,
  relatedQuestions,
  relatedArticles,
  author,
  prices,
}) => {
  const relatedService = question.relatedServices?.[0]

  return (
    <QuestionsAndAnswersQuestionPage
      type={QA_TYPE}
      breadcrumbTrail={breadcrumbTrail}
      category={category}
      question={question}
      relatedQuestions={relatedQuestions}
      relatedArticles={relatedArticles}
      author={author}
      prices={prices}
      mainCtaButton={
        relatedService
          ? {
              text: relatedService.mainCtaButtonText,
              linkHref: getRelatedServiceContent(relatedService.service)?.linkUrl,
              onClick: () =>
                analytics.track(
                  `Click on ${relatedService.mainCtaButtonText} (Trademark Q&As - Header)`,
                  {
                    category: category.slug,
                    question: question.slug,
                    service: relatedService.service,
                  },
                ),
            }
          : undefined
      }
    />
  )
}

export default TrademarkQAQuestion
